(() => {
  const init = async root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-ceb-form]');
    const select = form.querySelector('[data-variant-select]');
    const options = form.querySelector('[data-ceb-options]');
    const plans = form.querySelector('[data-ceb-plans]');
    const status = form.querySelector('[data-ceb-status]');
    const cta = form.querySelector('.cta');
    const quantity = form.elements.quantity;
    let ready = false;
    form.addEventListener('submit', event => { if (!ready) event.preventDefault(); });
    cta.disabled = true;
    cta.textContent = 'Loading purchase options…';
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:root.dataset.currency || 'USD'}).format(n / 100);
    const element = (tag, attrs = {}, text = '') => { const el = document.createElement(tag); Object.entries(attrs).forEach(([k,v]) => el.setAttribute(k,v)); el.textContent = text; return el; };
    let product;
    try {
      const response = await fetch(`${root.dataset.productUrl}.js`, {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Product information is unavailable.');
      product = await response.json();
    } catch (error) { status.textContent = 'Could not load purchase options. Refresh this page to try again.'; cta.textContent = 'Purchase options unavailable'; status.append(element('button', {type:'button', 'data-ceb-retry':''}, 'Try again')); status.querySelector('[data-ceb-retry]').addEventListener('click', () => location.reload()); return; }
    const isMorningBundle = product.handle === 'earlybird-morning-cocktail-variety-pack';
    const bundleVariant = isMorningBundle ? product.variants.find(v=>v.title==='Variety Pack') : null;
    if (isMorningBundle) product.variants = product.variants.filter(v=>v.title!=='Variety Pack');
    const groups = product.selling_plan_groups || [];
    const allPlans = groups.flatMap(g => g.selling_plans);
    const extras = JSON.parse(root.querySelector('[data-ceb-extras]')?.textContent || '{}');
    let variant = product.variants.find(v => String(v.id) === select.value) || product.variants[0];
    let purchase = 'one';
    let selectedPlan = variant.selling_plan_allocations?.[0]?.selling_plan_id || null;
    const dims = product.options.map((o,i) => ({name:typeof o === 'string' ? o : o.name, index:i, values:[...new Set(product.variants.map(v=>v.options[i]))]}));
    const purchaseDim = dims.find(d=>d.values.every(v=>/^(subscription|subscribe.*|one[ -]?time(?: purchase)?)$/i.test(v)));
    const requestedPlan = Number(new URL(location.href).searchParams.get('selling_plan'));
    const validRequestedPlan = variant.selling_plan_allocations?.some(a => a.selling_plan_id === requestedPlan);
    purchase = validRequestedPlan || (!new URL(location.href).searchParams.has('variant') && variant.selling_plan_allocations?.length > 0) || (purchaseDim && /^sub/i.test(variant.options[purchaseDim.index])) || product.requires_selling_plan ? 'sub' : 'one';
    if (validRequestedPlan) selectedPlan = requestedPlan;
    const selectedOptions = [...variant.options];
    const selectors = [];
    let secondVariant = product.variants.find(v=>v.available && v.id!==variant.id) || variant;
    let supplyDays = 90;
    const supplyField = element('fieldset');
    const supply = element('select',{id:'ceb-supply-'+root.dataset.sectionId});
    const secondField = element('fieldset');
    const secondSelect = element('select',{id:'ceb-second-'+root.dataset.sectionId});
    if (isMorningBundle) {
      supplyField.append(element('label',{for:supply.id},'Choose your supply'));
      supply.append(element('option',{value:'90'},'90-day supply · 2 tubs'),element('option',{value:'45'},'45-day supply · 1 tub'));
      supplyField.append(supply); options.append(supplyField);
      secondField.append(element('label',{for:secondSelect.id},'Second flavor'));
      product.variants.filter(v=>v.available).forEach(v=>secondSelect.append(element('option',{value:String(v.id)},v.title)));
      secondSelect.value=String(secondVariant.id);secondField.append(secondSelect);
      secondSelect.addEventListener('change',()=>{secondVariant=product.variants.find(v=>String(v.id)===secondSelect.value);renderPrice();});
      quantity.closest('.ceb-quantity').hidden=true;
      supply.addEventListener('change',()=>{supplyDays=Number(supply.value);selectedPlan=allPlans.find(p=>p.name.startsWith(supplyDays+'-'))?.id;render();});
    }
    dims.filter(d=>d !== purchaseDim).forEach(d => {
      const field = element('fieldset',{'class':'ceb-option-group'});
      field.append(element('legend',{},d.name.replace(/:$/, '')));
      const choices = element('div',{'class':/flavo[u]?r/i.test(d.name)?'ceb-flavor-list':'ceb-pack-list'});
      d.values.forEach(value => {
        const btn = element('button',{type:'button','class':'ceb-choice','data-option-index':String(d.index),'data-option-value':value},value);
        if (/flavo[u]?r/i.test(d.name)) { const sample=product.variants.find(v=>v.options[d.index]===value && v.featured_image?.src); if(sample) {const img=element('img',{src:sample.featured_image.src,alt:'',loading:'lazy',width:'64',height:'64'});btn.prepend(img);} }
        btn.addEventListener('click',()=> {
          selectedOptions[d.index] = value;
          resolveVariant(d.index);
          render();
        });
        choices.append(btn); selectors.push({btn,dim:d.index,value});
      });
      field.append(choices); options.append(field);
    });
    if (isMorningBundle) options.append(secondField);
    const purchaseField = element('fieldset'); purchaseField.append(element('legend',{},'Purchase option'));
    const sub = element('button',{type:'button','class':'opt','aria-pressed':'false'},'Subscribe & save');
    const one = element('button',{type:'button','class':'opt','aria-pressed':'false'},'One-time purchase');
    const frequencyLabel = element('label',{for:`ceb-frequency-${root.dataset.sectionId}`},'Delivery frequency');
    const frequency = element('select',{id:`ceb-frequency-${root.dataset.sectionId}`,name:'selling_plan'});
    sub.addEventListener('click',()=> {purchase='sub';resolveVariant();render();ready=true;});
    one.addEventListener('click',()=> {purchase='one';resolveVariant();render();ready=true;});
    frequency.addEventListener('change',()=> {selectedPlan=Number(frequency.value);render();});
    purchaseField.append(sub,frequencyLabel,frequency,one); plans.append(purchaseField);
    function resolveVariant(changedDimension) {
      if (purchaseDim) selectedOptions[purchaseDim.index] = purchaseDim.values.find(v=>purchase === 'sub' ? /^sub/i.test(v) : /^one/i.test(v));
      variant = product.variants.find(v=>v.options.every((v,i)=>v === selectedOptions[i]));
      if (changedDimension !== undefined && !variant?.available) {
        const alternative = product.variants.find(v=>v.available && v.options[changedDimension] === selectedOptions[changedDimension] && (!purchaseDim || v.options[purchaseDim.index] === selectedOptions[purchaseDim.index]));
        if (alternative) { variant = alternative; selectedOptions.splice(0, selectedOptions.length, ...variant.options); }
      }
    }
    function renderPrice() {
      const qty = isMorningBundle ? 1 : Number(quantity.value);
      const allocation = purchase === 'sub' ? variant?.selling_plan_allocations?.find(a=>a.selling_plan_id === selectedPlan) : null;
      const secondAllocation = purchase==='sub' ? secondVariant?.selling_plan_allocations?.find(a=>a.selling_plan_id===selectedPlan) : null;
      const secondPrice = isMorningBundle && supplyDays===90 ? (secondAllocation?.price ?? secondVariant.price) : 0;
      const valid = (!isMorningBundle || supplyDays!==90 || (secondVariant.available && (purchase!=='sub' || secondAllocation))) && variant?.available && Number.isInteger(qty) && qty > 0 && (purchase !== 'sub' || allocation);
      cta.disabled = !valid;
      cta.textContent = !variant || !variant.available ? 'Sold out' : purchase === 'sub' && !allocation ? 'Subscription unavailable' : 'Add to cart';
      root.querySelector('[data-ceb-price]').textContent = variant ? money(((allocation?.price ?? variant.price) + secondPrice) * (Number.isInteger(qty)&&qty>0?qty:1)) : 'Unavailable';
      const renewal = root.querySelector('[data-ceb-renew]');
      renewal.hidden = !allocation;
      if (allocation) {
        const plan = allPlans.find(p=>p.id === selectedPlan);
        const renewalPrice = allocation.price_adjustments?.at(-1)?.price ?? allocation.price;
        renewal.textContent = `${money((allocation.price + secondPrice) * qty)} today. Then ${money((renewalPrice + secondPrice) * qty)} per delivery. ${plan?.name || ''}. Automatically renews until canceled.`;
      }
    }
    const image = root.querySelector('.ceb-main-image');
    const imageUrls = product.images.map(i=>typeof i === 'string' ? i : i.src);
    let imageIndex = 0;
    function showImage(index) {
      if (!image || !imageUrls.length) return;
      imageIndex=(index+imageUrls.length)%imageUrls.length;
      image.removeAttribute('srcset'); image.src=imageUrls[imageIndex]; image.alt=`${product.title}, product image ${imageIndex+1}`;
      root.querySelector('[data-gallery-status]').textContent=`${imageIndex+1} / ${imageUrls.length}`;
      root.querySelectorAll('[data-gallery-index]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.galleryIndex)===imageIndex)));
      const strip=root.querySelector('.ceb-thumbnails');
      const active=root.querySelector('[data-gallery-index="'+imageIndex+'"]');
      if(strip?.clientWidth && active){
        const stripRect=strip.getBoundingClientRect(), thumbRect=active.getBoundingClientRect();
        strip.scrollTo({left:strip.scrollLeft+thumbRect.left-stripRect.left-(strip.clientWidth-thumbRect.width)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    root.querySelector('[data-gallery-prev]').addEventListener('click',()=>showImage(imageIndex-1));
    root.querySelector('[data-gallery-next]').addEventListener('click',()=>showImage(imageIndex+1));
    root.querySelectorAll('[data-gallery-index]').forEach(b=>b.addEventListener('click',()=>showImage(Number(b.dataset.galleryIndex))));
    function render() {
      if (variant) select.value=variant.id;
      selectors.forEach(({btn,dim,value})=>{
        btn.setAttribute('aria-pressed',String(selectedOptions[dim] === value));
        const candidate=product.variants.find(v=>v.available && v.options[dim]===value && (!purchaseDim || v.options[purchaseDim.index]===selectedOptions[purchaseDim.index]));
        btn.disabled=!candidate?.available;
      });
      const allocations=variant?.selling_plan_allocations || [];
      if (!allocations.some(a=>a.selling_plan_id===selectedPlan)) selectedPlan=allocations[0]?.selling_plan_id || null;
      frequency.replaceChildren();
      allocations.forEach(a=> {const p=allPlans.find(p=>p.id===a.selling_plan_id);frequency.append(element('option',{value:String(a.selling_plan_id)},p?.name || 'Subscription'));});
      if(isMorningBundle) {
        if(purchase==='sub') supplyDays=Number(allPlans.find(p=>p.id===selectedPlan)?.name.split('-')[0])||90;
        supply.value=String(supplyDays);secondField.hidden=supplyDays!==90;
      }
      frequency.value=String(selectedPlan); frequency.disabled=purchase!=='sub';
      frequency.hidden=frequencyLabel.hidden=purchase!=='sub';
      const kit=root.querySelector('[data-ceb-kit]');if(kit)kit.hidden=purchase!=='sub';
      sub.setAttribute('aria-pressed',String(purchase==='sub'));one.setAttribute('aria-pressed',String(purchase==='one'));
      one.disabled=product.requires_selling_plan === true;
      const hasSub=product.variants.some(v=>v.selling_plan_allocations?.length);
      sub.hidden=!hasSub; plans.hidden=!hasSub;
      status.textContent='';
      if (variant?.featured_image) {const normalized = url => new URL(url,location.href).href.split('?')[0];const idx=imageUrls.findIndex(url=>normalized(url)===normalized(variant.featured_image.src));if(idx>=0)showImage(idx);}
      renderPrice();
      if(variant) {const url=new URL(location.href);url.searchParams.set('variant',variant.id);if(purchase==='sub'&&selectedPlan)url.searchParams.set('selling_plan',selectedPlan);else url.searchParams.delete('selling_plan');history.replaceState(null,'',url);}
    }
    quantity.addEventListener('input',renderPrice);
    select.hidden=true; form.querySelector('.ceb-variant-label').hidden=true;options.hidden=false;
    resolveVariant();render();ready=true;
    root.addEventListener('submit',async event=> {
      if(event.target!==form)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(cta.disabled || form.dataset.pending) return;
      const qty=isMorningBundle ? 1 : Number(quantity.value);
      if(!variant?.available || !Number.isInteger(qty) || qty<1) return;
      form.dataset.pending='true';cta.disabled=true;cta.textContent='Adding…';status.textContent='';
      const item={id:variant.id,quantity:qty};if(purchase==='sub')item.selling_plan=selectedPlan;
      const detail=extras[String(variant.id)] || {};
      if(detail.preorder)item.properties={Preorder:'true'};
      const gifts=purchase==='sub' ? detail.subscriptionGifts || [] : detail.oneTimeGifts || [];
      const items=[...gifts.filter(Boolean).map(gift=>typeof gift==='object'?{...gift}:{id:gift,quantity:1}),item];
      if(isMorningBundle && (purchase==='sub' || supplyDays===90)) {
        const bundleId=String(Date.now());
        items.forEach(i=>{i.properties={...(i.properties||{}),'Bundle ID':bundleId};});
        if(supplyDays===90) {
          item.properties.Bundle=bundleVariant?.title || 'Variety Pack';
          items.push({id:secondVariant.id,quantity:1,...(purchase==='sub'?{selling_plan:selectedPlan}:{}),properties:{'Bundle ID':bundleId,Bundle:bundleVariant?.title || 'Variety Pack'}});
        }
      }
      try {
        const response=await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result=await response.json().catch(()=> { throw new Error('The cart could not be reached. Please try again.'); });
        if(!response.ok) throw new Error(result.description || result.message || 'Could not add this product. Please try again.');
        // Load the store cart so its existing gifts, discounts and checkout integrations run.
        location.assign(root.dataset.cartUrl);
      } catch(error) {status.textContent=error instanceof TypeError ? 'The cart could not be reached. Check your connection and try again.' : error.message || 'Could not add this product. Please try again.';root.querySelector('.ceb-view-cart').hidden=false;}
      finally {delete form.dataset.pending;renderPrice();}
    },true);
  };
  const start = scope => scope.querySelectorAll('[data-ceb-pdp]').forEach(init);
  start(document);
  document.addEventListener('shopify:section:load',event=>start(event.target));
})();
